var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import { LitElement, html } from 'lit';
import { customElement, property, state } from 'lit/decorators.js';
import './button.scss';
export var isLoading;
(function (isLoading) {
    isLoading["loading"] = "load";
    isLoading["done"] = "done";
})(isLoading || (isLoading = {}));
;
export var Variant;
(function (Variant) {
    Variant["primary"] = "dn-button";
    Variant["secondary"] = "dn-button--secondary";
    Variant["tertiary"] = "dn-button--tertiary";
    Variant["grey"] = "dn-button--grey";
    Variant["discard"] = "dn-button--discard";
})(Variant || (Variant = {}));
;
let Button = class Button extends LitElement {
    set disabled(bool) {
        const oldBool = this.disabled;
        this._disabled = bool;
        this.requestUpdate('disabled', oldBool);
    }
    get disabled() {
        return this._disabled;
    }
    constructor() {
        super();
        this.variant = 'dn-button';
        this.loading = 'done';
        this.submitted = false;
        this.noShadow = false;
        this.noTextTransform = false;
        this._disabled = false;
    }
    createRenderRoot() {
        return this;
    }
    render() {
        return html `
        <div @mousedown="${(e) => this.ripple(e)}">
            <button
                class="base-button ${this.variant} ${this.noShadow ? '' : 'button-shadow'} ${this.disabled ? 'disabled' : ''}"
                data-animation="ripple"
                .disabled=${this.disabled}
                @click="${(e) => this.clickEvent(e)}"
                style="${this.padding !== undefined ? 'padding: 0px ' + this.padding + 'px;' : 'padding: 0 1.5em;'} ${this.height !== undefined ? 'height: ' + this.height + 'px;' : ''} ${this.textColor ? `color: ${this.textColor} !important;` : ''}"
            >
            ${this.icon ? html `
                <i class="${this.icon}" style="padding-right: 1em;"></i>
            ` : ''}
            ${this.loading === 'load' ? html `
                    <img src="/static/ui/common/css/images/loading_white.svg"/>
                ` : this.calculateButtonText()}</button>
        </div>
        `;
    }
    calculateButtonText() {
        if (this.text) {
            if (!this.noTextTransform) {
                return this.text[0].toUpperCase() + this.text.substr(1).toLowerCase();
            }
            else {
                return this.text;
            }
        }
        else {
            return '';
        }
    }
    ripple(e) {
        const ripple = document.createElement('span');
        ripple.className = 'ripple';
        ripple.style.left = '87px';
        ripple.style.top = '-47px';
        ripple.style.setProperty('--scale', '348');
        e.target.appendChild(ripple);
    }
    clickEvent(e) {
        e.stopPropagation();
        setTimeout(() => {
            super.dispatchEvent(new Event('click'));
        }, 150);
    }
};
__decorate([
    property({ type: String })
], Button.prototype, "text", void 0);
__decorate([
    property({ type: String })
], Button.prototype, "variant", void 0);
__decorate([
    property({ type: String })
], Button.prototype, "loading", void 0);
__decorate([
    property({ type: Boolean })
], Button.prototype, "submitted", void 0);
__decorate([
    property({ type: Number })
], Button.prototype, "height", void 0);
__decorate([
    property({ type: Number })
], Button.prototype, "padding", void 0);
__decorate([
    property({ type: String })
], Button.prototype, "icon", void 0);
__decorate([
    property({ type: Boolean })
], Button.prototype, "noShadow", void 0);
__decorate([
    property({ type: String })
], Button.prototype, "textColor", void 0);
__decorate([
    property({ type: Boolean })
], Button.prototype, "noTextTransform", void 0);
__decorate([
    state()
], Button.prototype, "_disabled", void 0);
__decorate([
    property({ type: Boolean })
], Button.prototype, "disabled", null);
Button = __decorate([
    customElement('dn-button')
], Button);
export default Button;
